import { appendElement, appendElementIf } from '../xml-helpers';
import { buildInstitution } from './institution.builder';

export interface ContributorInput {
  givenName?: string;
  familyName: string;
  suffix?: string;
  affiliation?: {
    institution?: string;
    ror?: string;
  };
  orcid?: string;
  role:
    | 'first-author'
    | 'additional-author'
    | 'editor'
    | 'first-editor'
    | 'additional-editor'
    | 'chair'
    | 'reviewer'
    | 'review-assistant'
    | 'stats-reviewer'
    | 'reviewer-external'
    | 'reader'
    | 'translator';
}

function resolveRoleAndSequence(role: string): {
  contributor_role: string;
  sequence: string;
} {
  switch (role) {
    case 'first-author':
      return { contributor_role: 'author', sequence: 'first' };
    case 'additional-author':
      return { contributor_role: 'author', sequence: 'additional' };
    case 'first-editor':
      return { contributor_role: 'editor', sequence: 'first' };
    case 'additional-editor':
      return { contributor_role: 'editor', sequence: 'additional' };
    default: {
      return { contributor_role: role, sequence: 'additional' };
    }
  }
}

export function buildContributors(
  parent: Element,
  contributors: ContributorInput[]
): Element | null {
  if (!contributors || contributors.length === 0) return null;

  const contributorsEl = appendElement(parent, 'contributors');

  contributors.forEach((c) => {
    const { contributor_role, sequence } = resolveRoleAndSequence(c.role);

    const personName = appendElement(contributorsEl, 'person_name', null, {
      sequence,
      contributor_role,
    });

    appendElementIf(personName, 'given_name', c.givenName);
    appendElement(personName, 'surname', c.familyName);
    appendElementIf(personName, 'suffix', c.suffix);

    if (c.affiliation && (c.affiliation.institution || c.affiliation.ror)) {
      const affiliations = appendElement(personName, 'affiliations');
      buildInstitution(affiliations, c.affiliation.institution, c.affiliation.ror);
    }

    appendElementIf(personName, 'ORCID', c.orcid);
  });

  return contributorsEl;
}
